export default __webpack_public_path__ + "static/media/icon_complete.2ad31042.svg";